<template>
    <section class="client-settings--integration">
        <CameraSettings v-if="camModule === 1" />
        <IntegrationInportantDataSettings />
    </section>
</template>
<script charset="utf-8">
import CameraSettings from "./Parts/CameraApiAddressSettings.vue"
import IntegrationInportantDataSettings from "./Parts/IntegrationImportantDataSettings.vue"
import { encryptStorage } from '@/services/encrypt.service';
export default {
    name: "ClientSettingsIntegration",
    components: {
        CameraSettings,
        IntegrationInportantDataSettings
    },
    data() {
        return {
             camModule: encryptStorage.getItem('modules').cam,
        };
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.client-settings--integration {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
}
</style>
